import { type FC, memo } from 'react';
import Input, { type InputProps } from '.';
import searchIcon from '@assets/images/parrot/search.svg';

const SearchInput: FC<InputProps> = ({ suffix, ...rest }) => {
  return <Input {...rest} prefix={suffix || <img src={searchIcon} data-icon />} />;
};

export default memo(SearchInput);
